module.exports = __webpack_public_path__ + "static/media/novaseis.9e9619ee.jpg";